import React from 'react';
import store from '../../store/Store';

import Navigation from '../navigation/Navigation'
import PageSelection from '../pageSelection/PageSelection'

import './pageContent.scss';

type pageContentState = {
	article: any;
	navigation: any;
}

type pageContentProps = {
	article: any;
	navigation: any;
}

class PageContent extends React.Component<pageContentState, pageContentProps> {

  constructor(props) {
  	super(props)

  	this.state = {
  		article: props.article,
  		navigation: props.navigation
  	}
  }

  componentDidMount() {
	store.subscribe(() => {
		this.setState({
			article: store.getState().article,
			navigation: store.getState().navigation
		})
	})
  }

  renderPage = () => {
  	console.log('RENDER PAGE')
  }

  unusedCode = () => {
  	const { 
  		article 
  	} = this.state

  	{
		article.info.currentPage === 0 ? (
			<div
				className="InvisibleFrame"
				style={{
					backgroundImage: 'url( ' + '/images/background.jpg' + ' )',
					backgroundRepeat: 'no-repeat',
					backgroundSize: 'cover',
					backgroundPosition: 'center'
				}}
			/>
		) : (
			<div
				style={{
					height: '50px'
				}}
			/>
		)
	}

	<div
		className="TitleFrame"
	>
		<div
			className="BackgroundImageText"
		>

			{
				article.info.currentPage === 0 ? (
					<div
						className="BackgroundImageContent"
					>

						{ 
							article.pages.map((page, index, array) => {
								if (page.pageIndex === article.currentPage) {
									return page.images.map((image, innerIndex, innerArray) => {
										if (image.imageIndex === 0) {
											return (
												<div
													key={ index }
												>
													&copy; { image.imageCopyRight }
												</div>
											)
										}
									})
								}

								return true
							})
						}

					</div>
				) : (
					null
				)
			}

		</div>
			
		{
			article.info.currentPage === 0 ? (
				<div
					className="TitleText"
				>
					Titel
				</div>
			) : (
				null
			)
		}

		<div 
			className="ContentText"
		>

			{ 
				article.pages.map((page, index, array) => {
					if (page.pageIndex === article.info.currentPage) {
						return page.contributions.map((contribution, innerIndex, innerArray) => {
							if (contribution.contributionIndex === 0) {
								return (
									<div
										key={ index }
									>
										{ contribution.contributionText }
									</div>
								)
							}
						})
					}

					return true
				})
			}

		</div>
	</div>
  }

  render() {
  	  const { 
  	  	article,
  	  	navigation
  	  } = this.state;

	  return (
	  	<div
	  		className="PageContent"
	  	>

	  		{
	  			true ? (
	  				<div
	  					style={{
			  				position: 'absolute',
							top: 'calc(${ article.infocurrentPage } * 100%)',
							left: '0',
							width: '100vw'
			  			}}
			  		>
		  				
		  			</div>
	  			) : (
	  				null
	  			)
	  		}

	  		{
	  			true ? (
	  				<PageSelection 
	  					article={ article }
	  				/>
	  			) : (
	  				null
	  			)
	  		}

	  		{
	  			article.pages.map((page, index, array) => {
	  				if (article.info.currentPage === index) {
	  					this.renderPage()
	  				}
	  			})
	  		}

		</div>
	  );
	}
}

export default PageContent;